import React from "react";

import AlertsTemplate from "./AlertsTemplate";

const Cancelled = (props) => {
    return (
        <AlertsTemplate type={props.type} />
    )
}

export default Cancelled;